import { useQuery } from 'react-query'
import { getJSON } from 'common/services/api'
import { getQueryParams } from 'utils/getQueryParams'
import {
  MEDICATION_SCHEDULE_PATTERNS_QUERY_KEY,
  MEDICATION_SCHEDULE_PATTERNS_URL
} from './queryConstants'

type UseMedicationSchedulePatternsProps = {
  residentId: string
  includeStock: string
  enabled?: boolean
}

type UseMedicationSchedulePatternsReturn = {
  data: any
  isLoading: boolean
  refetch: () => void
}

export const useMedicationSchedulePatterns = ({
  residentId,
  includeStock,
  enabled = true
}: UseMedicationSchedulePatternsProps): UseMedicationSchedulePatternsReturn => {
  const params = getQueryParams({
    includeStock
  })

  const { data, isLoading, refetch } = useQuery(
    [MEDICATION_SCHEDULE_PATTERNS_QUERY_KEY, residentId, includeStock],
    () =>
      getJSON({
        url: `${MEDICATION_SCHEDULE_PATTERNS_URL}/${residentId}/list?${params}`
      }),
    {
      enabled: enabled && !!residentId,
      retry: 1
    }
  )

  return {
    data: data || null,
    isLoading,
    refetch
  }
}

export default useMedicationSchedulePatterns

